import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NotAuthGuard } from '../../core/auth';
import { I18nModule } from '../../core/i18n';
import { UrlModule } from '../../core/routing';
import { SpinnerModule } from '../../shared';
import { LoginComponent } from './desktop-login/login.component';
import { ForgotPasswordModule } from './shared/forgot-password/forgot-password.module';
import { ForgotUsernameModule } from './shared/forgot-username/forgot-username.module';
import { LoginFormModule } from './shared/login-form/login-form.module';
import { LoginHeaderModule } from './shared/login-header/login-header.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    UrlModule,
    LoginFormModule,
    ForgotPasswordModule,
    ForgotUsernameModule,
    SpinnerModule,
    LoginHeaderModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        DesktopLoginComponent: {
          component: LoginComponent,
          guards: [NotAuthGuard],
        },
      },
    }),
  ],
  providers: [],
  exports: [LoginComponent],
})
export class LoginModule {}
